module.exports = "/static/fonts/OpenSans-Regular.eot";